<template>
  <div class="mask" v-if="show" @click="closeMask"></div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    closeMask() {
      this.show = false;
      this.$emit("closeMask")
    }
  }
}
</script>

<style lang="less" soped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: transparent;
    z-index: 300;
}
</style>